import { render, staticRenderFns } from "./lawyerService.vue?vue&type=template&id=73ad3616&scoped=true"
import script from "./lawyerService.vue?vue&type=script&lang=js"
export * from "./lawyerService.vue?vue&type=script&lang=js"
import style0 from "./lawyerService.vue?vue&type=style&index=0&id=73ad3616&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ad3616",
  null
  
)

export default component.exports